import { unFormatPercent, toFixed, unFormatCurrency } from 'utils';

export const modelPortfolio = ({ funds, pound_values, fund_value }: any) => {
  const errors: any = {
    settings: {
      funds: {
        errors: null
      }
    }
  };
  if (!funds || funds.length < 1 || pound_values) {
    return;
  }

  if (fund_value) {
    const totalFundValue = Number(unFormatCurrency(fund_value));
    const totalInFunds = funds.reduce((acc: number, fund: any) => {
      acc += Number(unFormatCurrency(fund.fund_value));
      return acc;
    }, 0);
    if (totalFundValue === totalInFunds) {
      return;
    }
  }

  const sumPercentageValue = funds.reduce(
    (a: any, b: any) => {
      const fundA = Number(unFormatPercent(a.allocation || 0));
      const fundB = Number(unFormatPercent(b.allocation || 0));

      return {
        allocation: toFixed(fundA) + toFixed(fundB)
      };
    },
    {
      allocation: 0
    }
  );

  const percentageNotSumUp = sumPercentageValue.allocation !== 100;

  if (percentageNotSumUp) {
    errors.settings.funds.errors = 'Percentages do not sum up to 100%';
  }
  const fundIds = funds.reduce((acc: number[], fund: any) => {
    acc.push(fund.id);
    return acc;
  }, []);

  const hasDuplictates = new Set(fundIds).size !== funds.length;

  if (hasDuplictates) {
    errors.settings.funds.errors =
      'You cannot have duplicate funds in your model portfolio';
  }

  return errors;
};
